import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

export const debugModeGuard = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (!authService.isDeveloper()) {
    router.navigate(['/']);
    return false;
  }
  return true;
};
